import styled from '@emotion/styled'
import { Box, Button, Checkbox, createTheme, FormControlLabel, Grid, InputAdornment, Radio, TextField } from '@mui/material'
import React from 'react'
import { customStyles, justifyCenter } from '../../../styles'
import { BodyContainer } from '../../containers/BodyContainer'
import HomeIcon from '@mui/icons-material/Home';
import NumbersIcon from '@mui/icons-material/Numbers';
import MarkunreadMailboxIcon from '@mui/icons-material/MarkunreadMailbox';
import { ModalHeader } from '../../modals'
import { MainContainer } from '../../containers'
import { CaptionText, MainButton, MainInput, MainSelect } from '../../helpers'
import { useCustomForm } from '../../../hooks/useCustomForm'
import { useState } from 'react'
import { useEffect } from 'react'
import { Map } from './Map'
import { useDispatch, useSelector } from 'react-redux'
import { serviceType } from '../../../utils/service_type'
import { editAccountAction, newAccountAction } from '../../../actions/accountsAction'
import { autoFillAddress, resetForm } from '../../../slices/fillAddressSlice'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { useNavigate } from 'react-router-dom'
import { CustomAlert } from '../../helpers/alert/CustomAlert'
import { Stack } from '@mui/system'
import { setError } from '../../../slices/statusSlice'
import { getProducts } from '../../../actions'
import { animations } from '../../../utils/animations'
export const AddressForm = React.forwardRef((props, ref) => {
   const dispatch = useDispatch()
   const navigate = useNavigate()
   const { editMode, accountSelected, typeService:type } = useSelector(state => state.accounts)
   const autoFillAddress = useSelector(state => state.fillAddress)
   const { street, extNumber, intNumber, postalCode, colony, latitude, longitude} = autoFillAddress
   const [authorization] = useLocalStorage('login-token', null)
   const { id, reference:reference2, alias:name2, receiver:receiver2} = editMode && accountSelected[0]
   const [activeFade, setActiveFade] = useState(false)
   const { inputValues, handleOnChange, setNewValues } = useCustomForm({

      reference: '',
      name: '',
      reciever: '',
   })

   const [isValidate, setIsValidate] = useState(false)
   
   const { reference, name, receiver } = inputValues
   
   useEffect(() => {
      editMode && setNewValues({
         name: name2,
         reference: reference2,
         receiver: receiver2
      })
   }, [accountSelected])
   const handleBackward = () => {
      editMode
      ?  navigate(-1)
      : navigate('/dashboard/accounts')
   }
   const handleSubmit = () => {
      if(street && name.length > 2 && receiver.length > 2 || accountSelected[0]?.name.length > 0 && accountSelected[0].street.length > 0 && accountSelected[0].receiver.length > 0) {
         let address = editMode ? { ...accountSelected[0] } : {
            street, extNumber, intNumber, postalCode, colony, latitude, longitude, reference
         }
         const form = {
            name, type, receiver,
            address: address
         }
         
         editMode  
         ?  dispatch(editAccountAction(form, id,  authorization?.token)) 
         : dispatch(newAccountAction(form, authorization?.token))
         setActiveFade(true)
         setTimeout(() => {
            editMode
            // ? navigate('/dashboard/content')
            ? navigate(-1, { replace: true })
            : navigate('/dashboard/guardando')
         }, 1000);
         
      } else {
         const payload = {
            message: 'Campos: dirección, nombre y quien recibe son obligatorios.',
            status: 0
          }
         dispatch(setError(payload))
      }
   }
   return (
      <MainContainer >
         <ModalHeader text={!editMode ? 'Agregar una dirección' : `Editar direccion: ${name}`} bold color={customStyles.colors.main} backward action={handleBackward} />
         <Grid container spacing={2} className={ activeFade && animations.fadeOut } >

            <Grid item xs={12} >
               <Map />
               <CaptionText text="¿Tu dirección no coincide con el Pin del mapa?" underline color={customStyles.colors.main} />
            </Grid>

           {
            !editMode && 
            <>
                <MainInput
               label="* Calle"
               name="street"
               value={street}
               onChange={handleOnChange}
               columns={12}
               disabled
               />
               <MainInput
                  label="* No Ext"
                  name="extNumber"
                  value={extNumber}
                  onChange={handleOnChange}
                  columns={6}
                  disabled
               />
               <MainInput
                  label="No Int"
                  name="intNumber"
                  value={intNumber}
                  onChange={handleOnChange}
                  columns={6}
                  disabled
               />
            </>
           }
            <MainInput
               label="Referencia"
               name="reference"
               value={reference}
               onChange={handleOnChange}
               columns={12}
            />
            <MainInput
               label="* Alias"
               name="name"
               value={name}
               onChange={handleOnChange}
               columns={12}
            />
            <MainInput
               label="* Nombre de quien recibe"
               name="receiver"
               value={receiver}
               onChange={handleOnChange}
               columns={12}
            />
            {/* <TypeAddress />q */}
            <Grid item xs={12}>
               <FormControlLabel value={''} control={<Checkbox />} label="Usar como dirección de facturación"  />
            </Grid>
         </Grid>
         <Stack direction="row" spacing={3} className={ activeFade && animations.fadeOut }>

            <MainButton text="Cancelar" variant="outlined" size={customStyles.buttonSize.full} onClick={handleBackward} />

            <MainButton text={editMode ? 'Guardar cambios' : 'Guardar'} variant="contained" size={customStyles.buttonSize.full} onClick={handleSubmit}  />
         </Stack>
      </MainContainer>
   )
})
